module.exports = __webpack_public_path__ + "static/media/phey.bd503c31.ogg";